<template>
  <main data-preview-id="kb-category-main">
    <div class="content-container-outer">
      <div class="content-container">
        <div class="kb-breadcrumbs">
          <div class="kb-breadcrumbs__mobile-back">
            <svg
              class="kb-breadcrumbs__arrow kb-breadcrumbs__arrow--left"
              width="7"
              height="12"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M.055 5.7194c.018-.045.0518-.0835.0795-.125.0166-.0255.0322-.052.0489-.0775.007-.011.0116-.024.0216-.034L5.2426.2328c.2877-.3.7662-.3115 1.0685-.026a.7468.7468 0 0 1 .0262 1.0605L1.7954 6l4.5419 4.733a.7462.7462 0 0 1-.0262 1.0601.7563.7563 0 0 1-.5214.207.7568.7568 0 0 1-.547-.2325L.205 6.5174c-.01-.0105-.0146-.023-.0216-.0345-.0167-.025-.0323-.0515-.0489-.077-.0277-.0415-.0615-.08-.0796-.125-.0186-.0455-.0222-.0935-.0312-.141C.0147 6.0934 0 6.0474 0 5.9999c0-.047.0146-.093.0237-.1395.009-.0475.0126-.096.0312-.141"
                fill="#7C98B6"
                fill-rule="evenodd"
              />
            </svg>
            <a href="/qa">ホームに戻る</a>
          </div>
          <ol
            itemscope
            itemtype="http://schema.org/BreadcrumbList"
          >
            <li
              itemprop="itemListElement"
              itemscope
              itemtype="http://schema.org/ListItem"
            >
              <a
                itemprop="item"
                href="/qa"
              >
                <span itemprop="name">サポートトップ</span>
              </a>
              <meta
                itemprop="position"
                content="1"
              >
            </li>
            <svg
              class="kb-breadcrumbs__arrow kb-breadcrumbs__arrow--right"
              width="7"
              height="12"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.4905 5.7194c-.018-.045-.0518-.0835-.0795-.125-.0167-.0255-.0323-.052-.049-.0775-.007-.011-.0115-.024-.0216-.034L1.3028.2328c-.2876-.3-.7662-.3115-1.0684-.026a.7468.7468 0 0 0-.0262 1.0605L4.75 6l-4.542 4.733a.7462.7462 0 0 0 .0263 1.0601.7563.7563 0 0 0 .5213.207.7568.7568 0 0 0 .5471-.2325l5.0376-5.2501c.0101-.0105.0146-.023.0217-.0345.0166-.025.0322-.0515.0489-.077.0277-.0415.0614-.08.0795-.125.0187-.0455.0222-.0935.0313-.141.009-.0465.0237-.0925.0237-.14 0-.047-.0147-.093-.0237-.1395-.009-.0475-.0126-.096-.0313-.141"
                fill="#7C98B6"
                fill-rule="evenodd"
              />
            </svg>
            <li
              itemprop="itemListElement"
              itemscope
              itemtype="http://schema.org/ListItem"
            >
              <span itemprop="name">導入企業</span>

              <meta
                itemprop="position"
                content="2"
              >
            </li>
          </ol>
        </div>
        <div class="main-body">
          <Sidebar />
          <div class="kb-content">
            <div class="kb-article tinymce-content">
              <h1>
                <span
                  id="hs_cos_wrapper_name"
                  class="hs_cos_wrapper hs_cos_wrapper_meta_field hs_cos_wrapper_type_text"
                  style=""
                  data-hs-cos-general-type="meta_field"
                  data-hs-cos-type="text"
                >{{ faq_post.title }}</span>
              </h1>
              <h2 style="font-weight: 400;">
                {{ faq_post.sub_title }}
              </h2>
              <div v-html="faq_post.content" />
            </div>
            <RelatedArticle
              v-show="faq_post.post_relations.length > 0"
              :related-actical-list="faq_post.post_relations"
            />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from '@axios'
import { mapMutations } from 'vuex'
import RelatedArticle from '../components/RelatedArticle.vue'
import Sidebar from '../components/Sidebar.vue'

export default {
  name: 'FaqPage',
  components: {
    Sidebar,
    RelatedArticle
  },
  data() {
    return {
      title: '',
      faq_post: [],
    }
  },
  computed: {
    faqId() {
      return this.$route.params.faqId
    }
  },
  watch: {
    $route() {
      this.fetchFaqPost()
    }
  },
  mounted() {
    this.title = 'FAQ'
    this.fetchFaqPost()
  },
  methods: {
    ...mapMutations(['setOpenIds','setActiveId']),
    async fetchFaqPost() {
      try {
        const { data } = await axios.get(`/api/v2/faq_posts/${this.faqId}`)
        this.faq_post = data.faq_post
        this.setActiveId(data.faq_post.category_id)
      } catch (error) {
        this.$router.push({name:'not-found'})
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import "~styles/faq/faq-content.css";
</style>
